import { cilFile } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CForm } from '@coreui/react'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { TextareaAutosize } from '@mui/base'
import axios from 'axios'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { OverlayTrigger, Popover, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { setShowFeedback, setUserDetails } from 'src/redux/reducer/commomReducer.js/commonReducer'
import { setMessageList } from 'src/redux/reducer/messageReducer.js/messageReducer'
import deleteIcon from '../../assets/Delete-icon.svg'
import arrowIcon from '../../assets/dropdown-arrow.svg'
import emojiIcon from '../../assets/emojiIcon.svg'
import icallLogo from '../../assets/icall.svg'
import statusCircle from '../../assets/status-circle.svg'
import {
  createUserApi,
  fetchMessage,
  fetchMessagePagination,
  getConsultantName,
  getSiteAvailable,
  resendOtpApi,
  validateOtpApi,
} from '../../axios/api'
import './chat.css'
import { ageOfUser, genderArray, state } from './data'
import FeedbackForm from './FeedbackForm'
// import IconButton from '@material-ui/core/IconButton'
// import Snackbar from '@material-ui/core/Snackbar'
// import CloseIcon from '@material-ui/icons/Close'

const Chat = ({
  createSocketConnection,
  createMessage,
  setListMessage,
  listMessage,
  setAdminId,
  adminId,
  socket,
  setChatEnded,
  showFeedback,
  // setshowFeedback,
  setLoggedIn,
  userId,
  setUserId,
  userPhno,
  setUserPhno,
  endChat,
  setEndChat,
  intervalRef,
  setLastMessageTime,
  sendContinousMessage,
}) => {
  const [message, setMessage] = useState('')
  const [show, setShow] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const messagesEndRef = useRef(null)
  const [age, setAge] = useState()
  const [gender, setGender] = useState()
  const [country, setCountry] = useState()
  const [userOtp, setUserOtp] = useState('')
  const [showOtpForm, setShowOtpForm] = useState(false)
  const [formValid1, setFormValid1] = useState(false)
  const [formValid2, setFormValid2] = useState(false)
  const [userCreated, setUserCreated] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [fetchData, setFetchData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [consultant_name, setConsultant_name] = useState('---')
  const [selectedEmoji, setSelectedEmoji] = useState(false)
  // const [snackMsg, setSnackMsg] = useState('')
  // const [open, setOpen] = React.useState(false)
  const [site, setSite] = useState(false)
  const customExceptEmojis = Object.keys(data.emojis).filter(
    (v) =>
      ![
        'grinning',
        'laughing',
        'slightly_smiling_face',
        'innocent',
        'sweat_smile',
        'blush',
        'joy',
        'disappointed',
        'worried',
        'sob',
        'cry',
        'angry',
        '+1',
        '-1',
        'point_down',
        'point_left',
        'point_right',
        'point_up',
      ].includes(v),
  )
  // const [currPage, setCurrPage] = useState(1) // storing current page number
  // const [prevPage, setPrevPage] = useState(0) // storing prev page number
  // const [userList, setUserList] = useState([]) // storing list
  // const [wasLastList, setWasLastList] = useState(false) // setting a flag

  // const handleToClose = (event, reason) => {
  //   if ('clickaway' == reason) return
  //   setOpen(false)
  // }

  // const ranges = [
  //   '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
  //   '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
  //   '\ud83d[\ude80-\udeff]', // U+1F680 to U+1F6FF
  //   '[\u2600-\u26ff]',
  //   '[\uE000-\uF8FF]',
  //   '\uD83C[\uDC00-\uDFFF]',
  //   '\uD83D[\uDC00-\uDFFF]',
  //   '\uD83E[\uDD10-\uDFFF]',
  //   '\uD83E[\u1F90-\uDFFF]',
  //   '[\u2700-\u27BF]', // U+2700–U+27BF
  //   '\uD83C[\uDDE6-\uDDFF]',
  // ]
  const { user_details } = useSelector((state) => state.common)
  const dispatch = useDispatch()
  // const getAllMessages = async (userId) => {
  //   try {
  //     const { data, count } = await fetchMessagePagination({
  //       userId: user_details._id,
  //       page: 1,
  //       limit: 50,
  //     })
  //     setListMessage([...data])
  //     console.log('Count : ', count)
  //     // if (status === 200) {
  //     //   console.log(data)
  //     //   setListMessage([...data])
  //     // }
  //   } catch (error) {
  //     console.log(error.message)
  //   }
  // }
  const getAllMessages = async (userId) => {
    try {
      const { data, status } = await fetchMessage({ userId })
      if (status === 200) {
        setListMessage(data)
      }
    } catch (error) {
      console.log(error.message)
    }
  }
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const getIntialInfo = (data) => {
    try {
      if (data.adminId) {
        dispatch(setAdminId(data.adminId))
        getName()
      }
      getAllMessages(data.id)
    } catch (error) {
      setErrorMsg('Data not found.')
    }
  }

  const getName = async () => {
    if (adminId && adminId !== 'anonomyous') {
      try {
        const resp = await getConsultantName({ id: adminId })
        setConsultant_name(resp.data.consultant)
      } catch (error) {
        console.log(error.message)
      }
    } else {
      setConsultant_name('---')
    }
  }

  const getSite = async () => {
    try {
      const resp = await getSiteAvailable()
      setSite(resp.data.avaliable)
    } catch (error) {
      console.log(error.message)
    }
  }

  const createUser = async () => {
    try {
      setErrorMsg('')
      setLoading(true)
      const { data } = await createUserApi({
        phoneNumber: phoneNumber,
        age: age.value,
        gender: gender.value,
        country: country.value,
        login: true,
      })
      if (data.error) {
        if (data.code === 11000) {
          setErrorMsg('Number already taken')
        } else {
          setErrorMsg('Something went wrong')
        }
      } else if (data.success) {
        setShowOtpForm(true)
        setUserCreated(true)
        setErrorMsg('')
      }
      setLoading(false)
      setConsultant_name('---')
    } catch (error) {
      setErrorMsg('User creation failed.')
      setLoading(false)
    }
  }

  const validateOtp = async (e) => {
    try {
      setLoading(true)
      if (Number.isInteger(Number(userOtp)) && userOtp.toString().length === 6) {
        const { data } = await validateOtpApi({ phoneNumber, otp: userOtp })
        dispatch(setUserDetails(data.user))
        if (data.success) {
          const persistData = { token: data.token, id: data.user._id }
          if (data.token) {
            localStorage.setItem('userId', JSON.stringify({ token: data.token }))
          }
          if (data.user.loggedIn) {
            if (data.user.assignedBy) {
              persistData.adminId = data.user.assignedBy
            }
            getIntialInfo(persistData)
          } else if (data.token && localStorage.getItem('userId')) {
            const request = {
              from: adminId || 'anonomyous',
              to: data.user._id,
              message:
                "Hello, Thank you for reaching out to iCALL's ReYou, a Chat-line for youth." +
                '\n\nHere you will be talking to a trained professional counselor about any concern that is causing distress to you. ' +
                '\n\nKindly note that you are in a queue right now.\n' +
                '\n To get more details about our chat service, please visit the FAQ section( https://icallhelpline.org/reyou-faqs/ ) and Disclaimer section ( https://icallhelpline.org/disclaimers/ )',
              createdAt: new Date(),
            }
            setListMessage((prev) => {
              return [...prev, request]
            })

            createMessage(request)
          }
          setEndChat(data.user.endChat)

          setUserId(data.user._id)
          createSocketConnection(data.token)

          if (data) {
            setLastMessageTime(new Date().getTime() / 1000)
            if (data.user.assignedBy === null || data.user.assignedBy === undefined) {
              sendContinousMessage(data.user._id, adminId)
            }
            setFetchData(true)
            dispatch(setShowFeedback(false))
            setErrorMsg('')
            setUserOtp('')
            setGender('')
            setAge('')
            setCountry('')
          }

          setShowForm(false)
          setLoading(false)
        } else {
          setLoading(false)
          setErrorMsg('Invalid OTP!')
        }
      } else {
        setLoading(false)
        setErrorMsg('Invalid OTP!')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const submitOTPHandler = async (e) => {
    e.preventDefault()
    if (userCreated) {
      validateOtp(userOtp)
    } else {
      setErrorMsg('Create user first!')
    }
  }

  const popover1 = (
    <Popover id="popover-basic1" style={{ width: 'fit-content' }} className="border-0">
      <Popover.Body className="px-1 card" style={{ width: 'fit-content' }}>
        <div id="picker" style={{ maxHeight: '110px', overflow: 'hidden', width: '350px' }}>
          <Picker
            data={data}
            exceptEmojis={customExceptEmojis}
            theme="light"
            navPosition="none"
            searchPosition="none"
            skinTonePosition="none"
            previewPosition="none"
            maxFrequentRows={0}
            categories={['people']}
            onEmojiSelect={(e) => {
              setMessage(message + e.native)
              setSelectedEmoji(true)
            }}
          />
        </div>
      </Popover.Body>
    </Popover>
  )

  const popover2 = (
    <Popover id="popover2" className="popover2">
      <Popover.Body className="py-0">
        <div className="pt-3">
          <p className="m-2">
            <label>Phone number : </label>
            <strong>+91 {user_details?.phoneNumber}</strong>
          </p>
          <p className="m-2">
            <label> Age : </label>
            <strong> {user_details?.age} </strong>
          </p>
          <p className="m-2">
            <label> Gender : </label>
            <strong>{user_details?.gender != '' ? <> {user_details?.gender} </> : ' --- '}</strong>
          </p>
          <p className="m-2">
            <label> State : </label>
            <strong>
              {user_details?.country != '' ? <> {user_details?.country} </> : ' --- '}
            </strong>
          </p>
          {/* //remove it later */}
          {/* <p className="m-2">
            <label>Counselor Name : </label>
            <strong> {consultant_name ? consultant_name : ' --- '} </strong>
          </p> */}
        </div>
        <div>
          <button
            className="outline-btn w-100 p-2 btn-sm m-2 rounded-2 ms-0"
            onClick={() => {
              logout()
            }}
            style={{ cursor: 'pointer' }}
          >
            Logout
          </button>
        </div>
      </Popover.Body>
    </Popover>
  )

  function removeEmoji(str) {
    let strCopy = str
    let allowEmoji = selectedEmoji
    const emojiKeycapRegex = /[\u0023-\u0039]\ufe0f?\u20e3/g
    const emojiRegex = /\p{Extended_Pictographic}/gu
    const emojiComponentRegex = /\p{Emoji_Component}/gu
    if (emojiKeycapRegex.test(strCopy) && !allowEmoji) {
      strCopy = strCopy.replace(emojiKeycapRegex, '')
    }
    if (emojiRegex.test(strCopy) && !allowEmoji) {
      strCopy = strCopy.replace(emojiRegex, '')
    }
    if (emojiComponentRegex.test(strCopy) && !allowEmoji) {
      // eslint-disable-next-line no-restricted-syntax
      for (const emoji of strCopy.match(emojiComponentRegex) || []) {
        if (/[\d|*|#]/.test(emoji)) {
          continue
        }
        strCopy = strCopy.replace(emoji, '')
      }
    }
    setSelectedEmoji(false)
    return strCopy
  }

  const submit1 = (e) => {
    // let replaced = message.trim().replace(new RegExp(ranges.join('|'), 'g'), '')
    let replaced = removeEmoji(message)
    if (replaced.trim() !== '') {
      const request = {
        to: adminId || 'anonomyous',
        from: userId,
        message: replaced,
        endChat,
        createdAt: new Date(),
      }

      if (socket && socket.connected) {
        socket.emit('send-user', request)

        setListMessage((prev) => {
          return [...prev, request]
        })
        setMessage('')

        // clearInterval(intervalRef.current)
        // setLastMessageTime(new Date().getTime() / 1000)
        // sendContinousMessage(userId, adminId)

        setEndChat(false)
      } else {
        alert('No connection!!! Check your internet connection.')
      }
    } else {
      setMessage('')
    }
    setChatEnded(false)
    dispatch(setShowFeedback(false))
  }

  const submitMessage = (e) => {
    e.preventDefault()
    submit1()
  }

  const onDelBtnClick = () => {
    setShow(true)
  }

  const clearChat = () => {
    setListMessage([])
    socket.emit('clear-chat')
    handleClose()
  }

  const getFile = (message, name, type) => {
    switch (type) {
      case 'image/png':
      case 'image/gif':
      case 'image/jpeg':
        return (
          <a href={message} target="_blank" download>
            <img
              src={message}
              style={{
                objectFit: 'contain',
                width: 'auto',
                height: 'auto',
                maxHeight: '200px',
                maxWidth: '200px',
              }}
            />
          </a>
        )
      case 'video/mp4':
      case 'video/x-m4v':
      case 'video/*':
        return (
          <video width="200" height="100" controls>
            <source src={message} type="video/mp4" />
          </video>
        )
      case 'audio/mpeg':
      case 'audio/*':
        return (
          <audio controls className="audio2">
            <source src={message} type="audio/ogg" />
          </audio>
        )
      case 'application/msword':
      case 'text/csv':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/pdf':
      case 'text/xml':
      case 'application/x-zip-compressed':
      case 'application/vnd.ms-excel':
      case 'text/plain':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      case 'application/vnd.ms-powerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'text/html':
        return (
          <>
            <a href={message} style={{ display: 'flex' }} target="_blank" download>
              <CIcon
                id="file-icon"
                icon={cilFile}
                className="nav-icon"
                height={30}
                width={30}
                style={{ color: '#696969' }}
              />
              <span
                style={{
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {name}
              </span>
            </a>
          </>
        )
      default:
        break
    }
  }
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const isValidUrl = (urlString) => {
    let returnValue = false

    const regex2 = 'https://docs.google.com(.*?)/.*?'

    var urlPattern1 = new RegExp(
      '^((http|https)?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
      'i',
    )
    var urlPattern2 = new RegExp(`(${regex2})`)
    returnValue = urlPattern1.test(urlString.trim())
    if (!returnValue) {
      returnValue = urlPattern2.test(urlString.trim())
    }
    if (!returnValue) {
      returnValue = urlString
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
    }

    return returnValue
  }

  function FormValidation() {
    if (phoneNumber != '') {
      if (Number.isInteger(Number(phoneNumber))) {
        if (phoneNumber.length === 10) {
          setFormValid1(true)
          if (!age) {
            setErrorMsg('Age is required field')
            setFormValid2(false)
          } else if (!country) {
            setErrorMsg('State is required field')
            setFormValid2(false)
          } else if (!gender) {
            setErrorMsg('Gender is required field')
            setFormValid2(false)
          } else {
            setFormValid2(true)
          }
        } else {
          setErrorMsg('Phone number invalid.')
          setFormValid1(false)
        }
      } else {
        setErrorMsg('Phone number can not be text.')
        setFormValid1(false)
      }
    }
    if (formValid1 && formValid2) {
      try {
        createUser()
        setUserPhno(phoneNumber)
      } catch (error) {
        setErrorMsg('User creation failed')
      }
    }
  }

  const resendOtp = async () => {
    if (phoneNumber) {
      try {
        await resendOtpApi({ phoneNumber })
      } catch (error) {
        console.log(error.message)
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    FormValidation()
  }

  const logout = async () => {
    try {
      setLoading(true)
      if (localStorage.getItem('userId')) {
        setLastMessageTime('clear')
        const userData = JSON.parse(localStorage.getItem('userId'))
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userData.token}`,
        }

        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/user/update-user`,
          {
            _id: userId,
            update: {
              login: false,
            },
          },
          {
            headers: headers,
          },
        )
      }
      localStorage.clear()
      setErrorMsg('')
      setUserPhno('')
      setListMessage([])
      setPhoneNumber('')
      setUserId(null)
      setShowOtpForm(false)
      setFetchData(false)
      setShowForm(true)
      setLoggedIn(false)
      setFormValid1(false)
      setFormValid2(false)
      setConsultant_name('---')
      setLoading(false)
      clearInterval(intervalRef.current)
      socket.disconnect()
      dispatch(setAdminId('anonomyous'))
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      let online = window.navigator.onLine
      if (!online) {
        // setSnackMsg('You are offline! Please reload the page.')
        // setOpen(true)
        setErrorMsg('You are offline! Please reload the page.')
      } else {
        // setOpen(false)
        // setErrorMsg('')
      }
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  useEffect(async () => {
    const userData = JSON.parse(localStorage.getItem('userId'))
    if (!userData || showFeedback) {
      setShowOtpForm(false)
    }
    return () => {
      logout()
    }
  }, [])

  useEffect(() => {
    getSite()
  }, [])

  // useEffect(() => {
  //   if (userId) {
  //     const fetchMessages = async () => {
  //       const response = await fetchMessagePagination({ userId: userId, page: currPage, limit: 50 })
  //       console.log('Messsage Pagination response : ', response)
  //       if (!response.data.data.length) {
  //         setWasLastList(true)
  //         return
  //       }
  //       setPrevPage(currPage)
  //       setListMessage([...response.data.data])
  //     }
  //     if (!wasLastList && prevPage !== currPage) {
  //       fetchMessages()
  //     }
  //   }
  // }, [currPage, wasLastList, prevPage, userId])

  useEffect(() => {
    if (socket) {
      socket.off('chatCleared').on('chatCleared', () => {
        setListMessage([])
      })
    }
  }, [socket])

  useEffect(() => {
    FormValidation()
  }, [formValid1, formValid2])

  useEffect(() => {
    getName()
  }, [adminId, userId])

  useEffect(() => {
    scrollToBottom()
  }, [listMessage])

  useEffect(() => {
    if (!fetchData && userId) {
      setLoading(true)
      getAllMessages(userId)
      setLoading(false)
    }
  }, [fetchData, userId])

  const customStyles = {
    menuList: (base) => ({
      ...base,
      maxHeight: '150px', // your desired height
    }),
  }

  return (
    <>
      <div
        className="chatarea rounded-2"
      // style={
      //   !localStorage.getItem('userId') || showForm ? { minHeight: '400px' } : { height: '405px' }
      // }
      >
        <div className="chatarea_header rounded-top">
          <div className="logo">
            <img src={icallLogo} height={50} width={50} className="icall-logo" />
            <img src={statusCircle} className="statuscircle1" height={9} width={7} />
          </div>
          {localStorage.getItem('userId') && site ? (
            <>
              {' '}
              <span className="text-light mt-3 "> +91 {userPhno ? userPhno : phoneNumber}</span>
              <div style={{ display: 'inline', float: 'right', margin: '15px' }}>
                {!showFeedback && (
                  <img src={deleteIcon} onClick={onDelBtnClick} style={{ margin: '10px' }} />
                )}

                <OverlayTrigger trigger="click" placement="bottom" rootClose overlay={popover2}>
                  <img src={arrowIcon} height={20} width={20} style={{ cursor: 'pointer' }} />
                </OverlayTrigger>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
        {site ? (
          <>
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={
                  !localStorage.getItem('userId') || showForm
                    ? { minHeight: '400px' }
                    : { height: '405px' }
                }
              >
                <Spinner />
              </div>
            ) : (
              <div
                className="chat-fixed-div"
                style={
                  !localStorage.getItem('userId') || showForm
                    ? { minHeight: '350px' }
                    : { height: '350px' }
                }
              >
                {errorMsg != '' ? (
                  <>
                    <span
                      className="alert py-2 px-3 d-block m-1"
                      style={{ backgroundColor: '#E45353', color: '#fff' }}
                    >
                      {errorMsg}
                    </span>
                  </>
                ) : (
                  ''
                )}
                {!localStorage.getItem('userId') || showForm ? (
                  <>
                    <div className="overflow-form">
                      {showOtpForm ? (
                        <>
                          <div className="p-2 pt-2">
                            <p className="txt-black2 py-2">
                              We've sent a verification code to your phone number +91 {phoneNumber}
                            </p>
                            <Form className="pb-2" onSubmit={submitOTPHandler}>
                              <label className="pb-1"> OTP Code </label>
                              <input
                                className="form-control form-control-sm"
                                required={true}
                                type="text"
                                value={userOtp}
                                maxLength={6}
                                placeholder="Enter verification code"
                                onChange={(e) => {
                                  setUserOtp(e.target.value)
                                }}
                              />
                              <a onClick={resendOtp} className="float-end link-text pt-1">
                                Resend code?
                              </a>
                              <div className="pt-5">
                                <button
                                  type="submit"
                                  className="float-end px-4 py-2 submit-btn rounded-1"
                                >
                                  Submit
                                </button>
                                <button
                                  className="px-4 back-btn float-start txt-grey"
                                  onClick={() => {
                                    setErrorMsg('')
                                    setUserOtp('')
                                    setShowOtpForm(false)
                                  }}
                                >
                                  Back
                                </button>
                              </div>
                            </Form>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="p-2 py-1">
                            <span className="txt-black2 py-2">Please fill this form.</span>
                            <form onSubmit={handleSubmit}>
                              <div className="py-1">
                                <label className="pb-1">
                                  <strong>Phone number*</strong>
                                </label>
                                <input
                                  required={true}
                                  type="text"
                                  value={phoneNumber.trim()}
                                  onChange={(e) => {
                                    setPhoneNumber(e.target.value.trim())
                                  }}
                                  placeholder="Phone number"
                                  className="form-control form-control-sm"
                                  maxLength={10}
                                />
                              </div>
                              <div className="row py-1" style={{ overflow: 'visible' }}>
                                <div className="col">
                                  <label className="pb-1">
                                    <strong>Age*</strong>
                                  </label>
                                  <Select
                                    options={ageOfUser}
                                    value={age}
                                    styles={customStyles}
                                    required
                                    placeholder="Age"
                                    onChange={(e) => {
                                      setAge(e)
                                    }}
                                    onInputChange={(data) => {
                                      if (data) {
                                        setAge('')
                                      }
                                    }}
                                  />
                                </div>
                                <div className="col">
                                  <label className="pb-1">
                                    <strong>Gender*</strong>
                                  </label>
                                  <Select
                                    options={genderArray}
                                    value={gender}
                                    styles={customStyles}
                                    placeholder="Gender"
                                    onChange={(e) => {
                                      setGender(e)
                                    }}
                                    onInputChange={(e) => {
                                      if (e) {
                                        setGender('')
                                      }
                                    }}
                                  />
                                </div>
                                <div className="py-2">
                                  <label className="pb-1">
                                    <strong>State*</strong>
                                  </label>
                                  <Select
                                    options={state}
                                    value={country}
                                    required
                                    styles={customStyles}
                                    placeholder="Select State"
                                    onChange={(e) => {
                                      setCountry(e)
                                    }}
                                    onInputChange={(e) => {
                                      if (e) {
                                        setCountry('')
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <button
                                className="default-btn float-end px-3 py-1 me-3 mt-3"
                                type="submit"
                              >
                                Submit
                              </button>
                            </form>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="chatarea__container overflow"></div>
                    {showFeedback ? (
                      <>
                        <FeedbackForm
                          logout={logout}
                          // setshowFeedback={setshowFeedback}
                          userId={userId}
                          consultantId={adminId}
                          className="p-0 m-0"
                        />
                      </>
                    ) : (
                      <>
                        <div className="chatarea__messages overflow ">
                          {listMessage.map((item, index) => {
                            return (
                              <div
                                key={index}
                                className={
                                  userId
                                    ? userId === item.from
                                      ? 'sendermessage'
                                      : 'receivermessage'
                                    : 'receivermessage'
                                }
                                ref={messagesEndRef}
                              >
                                {item.type ? (
                                  <>
                                    <p> {getFile(item.message, item.name, item.type)}</p>
                                    <p className="time">
                                      <span className="otime">
                                        {moment(item.createdAt).format('h:mm a')}
                                      </span>
                                      &nbsp;
                                      <span className="date">
                                        {moment(item.createdAt).format(' DD/MM/YY ')}
                                      </span>
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="text">
                                      {item?.message?.length > 0 &&
                                        item.message?.split(/(\s+)/).map((e) => {
                                          return isValidUrl(e) ? (
                                            <>
                                              {e === 'icall@tiss.ac.in' ? (
                                                <a href="mailto: icall@tiss.ac.in" target="_blank">
                                                  {e}
                                                </a>
                                              ) : (
                                                <a href={e} target="_blank">
                                                  {e}
                                                </a>
                                              )}
                                            </>
                                          ) : (
                                            <> {e}</>
                                          )
                                        })}
                                    </p>
                                    <p className="time">
                                      <span className="otime">
                                        {moment(item.createdAt).format('h:mm a')}
                                      </span>
                                      &nbsp;
                                      <span className="date">
                                        {moment(item.createdAt).format(' DD/MM/YY ')}
                                      </span>
                                    </p>
                                  </>
                                )}
                              </div>
                            )
                          })}
                        </div>
                        <div className=" type_section position-absolute w-100 rounded-bottom">
                          <CForm
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && e.ctrlKey) {
                                setMessage(message + '\n')
                                e.target.scrollTop = e.target.scrollHeight
                              }
                              if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey) {
                                e.preventDefault()
                                submit1()
                              }
                            }}
                          >
                            <div className="row bottom-0 bg-w mt-1 py-2 ms-1">
                              <div className="col-1 my-1">
                                <OverlayTrigger
                                  trigger="click"
                                  placement="top"
                                  style={{ width: '290px' }}
                                  overlay={popover1}
                                  rootClose
                                >
                                  <img
                                    src={emojiIcon}
                                    className="float-emoji m-auto"
                                    style={{ cursor: 'pointer' }}
                                  />
                                </OverlayTrigger>
                              </div>
                              <div className="col-8 pe-0">
                                <TextareaAutosize
                                  maxRows="1"
                                  required={true}
                                  type="text"
                                  value={message}
                                  style={{
                                    resize: 'none',
                                    overflow: 'auto',
                                    // minheight: '30px',
                                    height: '100%',
                                    maxHeight: '60px',
                                  }}
                                  ref={messagesEndRef}
                                  onChange={(e) => setMessage(e.target.value)}
                                  placeholder="Type Here"
                                  className="form-control form-control-sm py-1 large-2"
                                />
                              </div>
                              <div className="col-3">
                                <button
                                  className="chat_button mx-1"
                                  type="submit"
                                  onClick={submitMessage}
                                >
                                  SEND
                                </button>
                              </div>
                            </div>
                          </CForm>
                        </div>
                        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
                          <Modal.Body>Do you want to delete your chat history ?</Modal.Body>
                          <Modal.Footer className="p-0">
                            <Button variant="mutted border py-1 btn-sm" onClick={handleClose}>
                              Cancel
                            </Button>
                            <Button
                              className="default-btn py-1 my-2 text-light btn-sm me-4"
                              onClick={clearChat}
                            >
                              Delete
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            <div className="chatarea__messages overflow ">
              <div className={'receivermessage'} ref={messagesEndRef}>
                <p className="text">
                  Unfortunately, our services are unavailable at the moment. You may reach out to us
                  from Monday - Friday 9am to 9pm.
                  <br />
                  <br />
                  Meanwhile, you may access iCALL's other self-help resources here:
                  <br />
                  <br />
                  &nbsp;&nbsp; ■ &nbsp;&nbsp;Download ReYou, iCALL's Mental Health App here:
                  <a
                    href="https://play.google.com/store/apps/details?id=org.codeb.IcallApp"
                    target="blank"
                    className="text-break"
                  >
                   {" "}https://play.google.com/store/apps/details?id=org.codeb.IcallApp
                  </a>
                  <br />
                  <br />
                  &nbsp;&nbsp; ■ &nbsp;&nbsp;Website:
                  <a href="https://icallhelpline.org/" className="text-break">{" "}https://icallhelpline.org/</a>
                  <br />
                  <br />
                  Or if you wish to have in-person therapy, you may refer to the crowdsourced list
                  of mental health professionals:{" "}
                  <a
                    href="https://docs.google.com/spreadsheets/d/1pzckT6ns2H1IlmwYwJa8EnBh_1u3gRA9cEOoA4zfilc/edit#gid=370032083"
                    className="text-break"
                  >
                    https://docs.google.com/spreadsheets/d/1pzckT6ns2H1IlmwYwJa8EnBh_1u3gRA9cEOoA4zfilc/edit#gid=370032083
                  </a>
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}
export default Chat
